import React, {Component} from 'react';
import GameEntry from './GameEntry';
import "./styles/games.css";

class Games extends Component{
  render(){
    return(
      <div>
        <h1>Games</h1>
        <ul className="spreadOut" id="gameLinks">
          <a href="#vr">Virtual Reality/Augmented Reality</a>
          <a href="#slots">Slot machine/Gaming</a>
          <a href="#social">Social Network games</a>
          <a href="#education">Educational</a>
          <a href="#compSci">Games for teaching STEM</a>
          <a href="#fun">Games made for fun</a>
        </ul>
        
        <h2 id="vr">Virtual Reality/Augmented Reality Games and Experiences</h2>        
        
        <GameEntry title="CBS AR Weather Forecast">
            <iframe width="560" height="315" src="https://www.youtube.com/embed/9Cckp3Wmic8?si=ARhlyGw-LKnTARwh" title="CBS AR Weather Forecast" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
            <p>This forecast was made using a virtual set mapped onto a greenscreen studio using position tracking hardware for the talent and cameras. AR effects are triggered using an iPad or a custom handheld Stream Deck.</p>
        </GameEntry>
        <GameEntry title="SimX VR Medical Training">
            <iframe width="560" height="315" src="https://www.youtube.com/embed/beajqw-F6tQ?si=nStF1LZ0YGUhuFCv" title="SimX virtual training" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
            <p>At SimX I worked on over 100 different VR medical training scenarios. This included simulations for military, emergency medical services, and nursing scenerios.</p>
        <img src="./images/simx/cuffLeak1.webp" alt=""/>
        <img src="./images/simx/cuffLeak2.png" alt=""/>
        <img src="./images/simx/cuffLeak4.webp" alt=""/>
        <br/>
        <img src="./images/simx/sepsis1.webp" alt=""/>
        <img src="./images/simx/sepsis2.webp" alt=""/>
        <img src="./images/simx/sepsis3.webp" alt=""/>
        <img src="./images/simx/sepsis5.png" alt=""/>
        <br/>
        <img src="./images/simx/climbing.webp" alt=""/>
        <img src="./images/simx/trach3.png" alt=""/>
        <img src="./images/simx/trach2.png" alt=""/>
        <img src="./images/simx/trach1.webp" alt=""/>
        <img src="./images/simx/birthPlan.png" alt=""/>
        
        
        </GameEntry>
        <GameEntry title="The Rabbit Who Overcame Fear AR Book">
        <a href="./jataka/index.html"><img src="./images/jataka.jpg" alt="Jataka AR experience"/></a>
        <p>This is a demo I created for the children's book "The Rabbit Who Overcame Fear". It features different types of interactions including image tracking to display animation, clickable virtual objects, and buttons that use text-to-speech to read words and passages out loud.</p>
        </GameEntry>
         <GameEntry title="Whack-a-Mole AR">
        <a href="./aframe/whackAMole.html"><img src="./images/whackAMole.jpg" alt="whack a mole game"/></a>
        <p>This project was started when a friend of mine had a game made with Meta's SparkAR. As soon as the game was made, SparkAR was retired and so the game would no longer work. I suggested remaking the game using AFrame since it could work on a variety of platforms and did not have to be available in a market store. This is a simple whack-a-mole game where you click on the cat burglars and avoid the police dogs.</p>
        </GameEntry>
        {/*
        <GameEntry title="The Cursed Kingdom">
          This Augmented Reality puzzle has players set out on a quest to cure a mysteriously cursed kingdom. Players combine different items to create new ones and use their new powers to cure the mysterious sickness that plagues the kingdom. This game was designed to be a short experience for players waiting to enter a real-world escape game. The game uses escape room flyers as game pieces and encourages players to take the flyers home to finish the game at their leisure.
        </GameEntry>
        
        <GameEntry title="Pokemon Hunt">
          In this Augmented Reality experience you search for Pokemon in your real world. Then see which ones you discover and watch them come alive.
        </GameEntry>
        
        <GameEntry title="USAF missing leg">
        Traing for treating a patient whose leg was blown off
        </GameEntry>
        
        <GameEntry title="Something with a kid">
        Traing for treating a patient whose leg was blown off
        </GameEntry>
        
        <GameEntry title="Ambulance case">
        Traing for treating a patient whose leg was blown off
        </GameEntry>
        
        <GameEntry title="Tent case">
        Traing for treating a patient whose leg was blown off
        </GameEntry>
       */}
        
        <h2 id="slots">Online Slot Games</h2>

        <GameEntry title="Pharaoh's Fortune">
          Feel like a king with this classic iconic theme which features five reels, 15 paylines, and is filled with entertaining animation sequences and great music.
          <iframe title="Pharaoh's Fortune Slots" width="560" height="315" src="https://www.youtube.com/embed/b1Poffi5hGI" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
          <a target ="_blank" rel="noopener noreferrer" href="https://www.penny-slot-machines.com/games/pharaohs-fortune-slots.html">Play Pharaoh's Fortune online here.</a>
        </GameEntry>

        <GameEntry title="Black Widow">
          Black Widow online video slot game is a 5-reel slot machine with a fixed 40 lines. This game is entertaining and offers a ton of unique features not found in many other games including the web capture feature and the super stacks feature.
          <iframe title="Black Widow Slots" width="560" height="315" src="https://www.youtube.com/embed/CNG_8zDoRVk" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
        </GameEntry>

        {/*
        <GameEntry title="Double DaVinci Diamonds">
          Inspired by the original DaVinci Diamonds® Video Slots, one of the most successful themes ever released, this new addition to the successful Tumbling Reels® game family is sure to be a player favorite.
          <iframe width="560" height="315" src="https://www.youtube.com/embed/WaWu47T7zMM" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
        </GameEntry>
        */}

        <GameEntry title="Golden Goddess">
          Win the favor of the Goddess on every spin!
          Selective Stacking locks a major symbol on each spin for exciting base game play and larger payouts
          Players choose their Super Stacks™ in the bonus to create giant wins in the feature
          Features a Free Games bonus with Stacked Wilds® and eye-catching graphics
          Configurable line options all on one game program support multiple denomination segments
          Increased stacks in the Free Games produce jaw-dropping wins.
          <iframe title="Golden Goddess Slots" width="560" height="315" src="https://www.youtube.com/embed/ThuJJ-0243M" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
          <a target ="_blank" rel="noopener noreferrer" href="https://www.penny-slot-machines.com/games/golden-goddess.html">Play Golden Goddess online here.</a>
        </GameEntry>

        <GameEntry title="Cats">
          Calling all animal lovers! Cats free online slot will not leave you indifferent if you wish to play casino games online and enjoy the animal theme. Indeed, this fabulous 5-reel, 30-line game is one of the main attention-grabber’s on the net.
          <iframe title="Cats Slots" width="560" height="315" src="https://www.youtube.com/embed/He-lafr7TKQ" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
          <a target ="_blank" rel="noopener noreferrer" href="https://www.penny-slot-machines.com/games/cats.html">Play Cats online here.</a>
        </GameEntry>

        <GameEntry title="Cleopatra">
          Take a Trip Down the Nile and Unravel the Mysteries of Ancient Egypt.
          <iframe title="Cleopatra Slots" width="560" height="315" src="https://www.youtube.com/embed/sLipA7bxqAo" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
          <a target ="_blank" rel="noopener noreferrer" href="https://www.penny-slot-machines.com/games/cleopatra-slots.html">Play Cleopatra online here.</a>
        </GameEntry>

        <GameEntry title="Wolf Run">
          Wolf Run online slots, one of the most popular slots from IGT, is a 5-reel, 40-payline game that features Stacked Wilds, amazing big wins and a super-rich, retriggering Free Spins bonus. On every reel there are stacks of four or more wild symbols.
          <iframe title="Wolf Run Slots" width="560" height="315" src="https://www.youtube.com/embed/L0_FKyWhE2E" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
          <a target ="_blank" rel="noopener noreferrer" href="https://www.penny-slot-machines.com/games/wolf-run-slots.html">Play Wolf Run online here.</a>
        </GameEntry>

        <h2 id="social">Social Network Games</h2>

        <GameEntry title="Diner Dash: Facebook">
          <p>The premise of Diner Dash on Facebook follows Flo and her continuous battle against the evil Mr. Big. Mr. Big has polluted the DinerTown park forcing most restaurants to close. Players must help Flo take on Mr. Big and use their tips earned in the restaurant to fix the park, allowing other restaurants to be unlocked.</p>
          <img src="./images/dinerDash1.jpg" alt="clean and decorated park in Diner Dash"/>
          <img src="./images/dinerDash2.jpg" alt="diner in Diner Dash"/>
          <img src="./images/dinerDash3.jpg" alt="the world map of Diner Dash"/>
          <img src="./images/dinerDash4.jpg" alt="the trash in the park in Diner Dash"/>
        </GameEntry>
        
         <GameEntry title="Top Girl: Android">
          <p>Are you addicted to shopping and fashion? Do you dream of being a supermodel? Love to go on dates? Do it all and become the TOP GIRL! See why millions of other girl gamers can't stop playing this leading fashion game! Create FABULOUS outfits and have fun with your new boyfriend. Kiss him, buy him gifts, and go on exciting dates! Capture and save photos of all your special moments together!</p>
          <iframe width="560" height="315" src="https://www.youtube.com/embed/qBoinycJL74?si=RHv6osCWds1X1K1v" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>        
          <img src="./images/topGirl1.jpg" alt="Top Girl title screen"/>        
          <img src="./images/topGirl2.png" alt="store filled with clothes on sale"/>        
          <img src="./images/topGirl3.jpg" alt="travel to L.A. and New York postcards"/>        
          <img src="./images/topGirl4.jpg" alt="town street corner with character and friend connections"/>
        </GameEntry>

        <h2 id="education">Educational Games</h2>

        <GameEntry title="MySecureCyberspace Game: Carnegie Cadets">
          <p>The goal of the MySecureCyberspace Game is to educate children ages 8-11 about cybersecurity and instill in them good cybercitizen habits so that being safe and secure online becomes as second nature as brushing your teeth or looking both ways before crossing the street. The player is a trainee in the Carnegie Cyber Academy who must enter CyberSpace, the city that exists inside the Internet to learn about cybersecurity. The player completes several missions, mini-games designed to teach major cybersecurity principles such as how to use judgement when sorting and opening email and what is safe information to share with others online.</p>
          {/*<a href="http://www.carnegiecyberacademy.com">Visit the game page.</a>*/}
          <img src="./images/cc1.jpg" alt="Commander Omni's office"/>
          <img src="./images/cc2.jpg" alt="an email sorting game"/>
          <img src="./images/cc3.jpg" alt="Betty at the entrance to the chat room"/>
          <img src="./images/cc4.jpg" alt="Cadet Carlo's bedroom"/>
          <img src="./images/cc5.jpg" alt="the Academy Store"/>
          <img src="./images/cc6.jpg" alt="the Academy Cafeteria"/>
          <img src="./images/cc7.jpg" alt="Trey at the email sorting center"/>
        </GameEntry>

        <GameEntry title="Find My Instruments!">
          <p>A hidden object game which teaches children about the sorts of tools they might find a doctor using. The game takes place in a patient waiting room where a doctor asks the player to look for his instruments. As each tool is collected more information about that tool is revealed. The idea behind this game is that if the children know what a doctor's instruments are for, they will not feel frightened when they visit a real doctor's office.</p>
          <img src="./images/instruments.jpg" alt="a doctor's waiting room"/>
        </GameEntry>
        <GameEntry title="Against All Odds Exhibit: Global Health Everywhere Games">
        <p>These games were created to compliment the Against All Odds exhibit for global health at the National Library of Medicine. Each game focuses on geography in the context of world health. These games are accessible to the mobility and vision impaired.</p>
        <figure>
          <img src="./images/NIHgame1.png" alt="a word scramble game"/>
          <figcaption>Unscramble the name.</figcaption>
        </figure>
        <figure>
          <img src="./images/NIHgame2.jpg" alt="a world map showing health information"/>
          <figcaption>Global Health Everywhere games.</figcaption>
        </figure>
        <figure>
          <img src="./images/NIHgame3.png" alt="screenshot of a multiple choice global health quiz"/>
          <figcaption>Test your knowledge game.</figcaption>
        </figure>
        <figure>
          <img src="./images/NIHgame4.png" alt="matching game depicting world health leaders"/>
          <figcaption>Who's who in global health game.</figcaption>
        </figure>
        <a href="https://www.nlm.nih.gov/exhibition/againsttheodds/online_activities/index.html">Play the games here.</a>
        </GameEntry>
        <h2 id="compSci">Games for teaching STEM</h2>
        <p>I've made a variety of games for teaching coding concepts.</p>

        <GameEntry title="Blob.io">
          <p>This game started as a clone of the popular online game agar.io. I designed this game to demonstrate classes and effectively using inheritance to easily add more complex game behavior without having to write a lot of extra code. It has become a student favorite.</p>
          <a href="./p5/blobio.html"><img src="./images/blobio.png" alt="colorful circles represent enemies in blob.io"/></a>
        </GameEntry>
        
        <GameEntry title="Dungeon Crawl">
          <p>This game was created to teach students how to use object-oriented programming and inheritance to make a more complex game.</p>
          <a href="./p5/dungeonCrawl.html"><img src="./images/dungeon.png" alt=""/></a>
        </GameEntry>

        {/*<GameEntry title="Class inheritance and Creating a sprite class">
        This simple Java Script game was created to demonstrate using classes and inheritance. The sprite class has been used by my students as a basis for writing their own classes and as a base class to extend to create sprites with more complex behavior.
        Game with dog catching bats.
        </GameEntry>*/}
        <h2 id="fun">Games made for fun</h2>
        <GameEntry title="Metamorphosis">
          <p>Metamorphosis is an object avoidance game inspired by Kafka's work of the same name. This demo demonstrates the game play and showcases a new type of collision detection based on analyzing bitmap data. <a href="http://animateinexile.blogspot.com/2008/08/bitmap-collision-detection.html">Read more about Bitmap Collision Detection at my old blog.</a> The original game was made in Flash and is no longer available.</p>
          <img src="./images/metamorphosis.gif" alt="an object avoidance game where the player is a cockroach"/>
        </GameEntry>
        
      </div>
    );
  }
}

export default Games;
